import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/detailsPopup/styles.scss';export default {
  "resizePopup": "_resizePopup_ce182_1",
  "popup": "_popup_ce182_7",
  "name": "_name_ce182_19",
  "text": "_text_ce182_26",
  "label": "_label_ce182_32"
};